// extracted by mini-css-extract-plugin
export var container = "_1j-0";
export var disabled = "_1j-4";
export var fullWidth = "_1j-3";
export var lined = "_1j-1";
export var selected = "_1j-5";
export var tab = "_1j-2";